import React from 'react';
import { Flex, Tooltip, Tag } from 'antd';
import Icon from '@mdi/react';
import { mdiAccountDetailsOutline, mdiHandshakeOutline, mdiAnchor, mdiEye, mdiCash } from '@mdi/js';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import getFormattedValue from 'store/redux/utils/getFormattedValue';

const CountIcons = ({ data }) => {
  const items = [
    { key: 'leads_count', icon: mdiAccountDetailsOutline, label: 'Leads' },
    { key: 'deals_count', icon: mdiHandshakeOutline, label: 'Deals' },
    { key: 'postbacks_count', icon: mdiAnchor, label: 'Postbacks' },
  ];

  if (!data) return null;

  return (
    <Flex gap='small' align='center'>
      {items.map((item) => {
        const count = data[item.key];

        if (!count) return null;
        return (
          <Tag className='rounded-md h-6 flex items-center justify-center m-0 border border-solid border-info-background'>
            <Tooltip
              destroyOnHidden
              className='cursor-pointer'
              key={item.key}
              title={`${item.label}: ${count}`}
            >
              <Icon className='text-info hover:text-blue' path={item.icon} size={0.8} />
            </Tooltip>
          </Tag>
        );
      })}
      {data?.pageviews_count > 0 && (
        <Tooltip title='Page Views'>
          <Tag className='rounded-md h-6 text-sm font-normal flex gap-1 items-center justify-center m-0 border border-solid border-info-background'>
            <Icon className='text-info hover:text-blue' path={mdiEye} size={0.8} />
            {getFormattedNumber(data?.pageviews_count)}
          </Tag>
        </Tooltip>
      )}
      {data?.revenue !== undefined && (
        <Tooltip title='Revenue'>
          <Tag className='rounded-md h-6 text-sm font-normal flex gap-1 items-center justify-center m-0 border border-solid border-info-background'>
            <Icon className='text-info hover:text-blue' path={mdiCash} size={0.8} />
            {getFormattedValue(data?.revenue)}
          </Tag>
        </Tooltip>
      )}
    </Flex>
  );
};

export default CountIcons;
